export default __webpack_public_path__ + "static/media/Mark-2-Blueprints-02.7179735b.jpg";